// #521 — a tela de suspensão (Payments.vue) sempre mostrava "regularize
// sua(s) fatura(s)", mesmo pra conta sem NENHUMA fatura em aberto (ex.:
// login do titular bloqueado sem cobrança pendente associada). Mensagem
// passa a depender de existir fatura EFETIVAMENTE ABERTA — não qualquer
// registro de pagamento.
//
// Correção da rodada Gate Codex: "fatura aberta" != "tem algum item em
// `payments`". Um pagamento já RECEIVED/CONFIRMED (pago) ou REFUNDED
// (estornado) não é uma pendência — só PENDING (aguardando pagamento) e
// OVERDUE (vencida) são, no vocabulário de status que a Asaas devolve
// (consumido em `api/services/Asaas.js` / `WebhookController.js`, que
// mapeia os eventos PAYMENT_CONFIRMED/PAYMENT_RECEIVED/PAYMENT_OVERDUE/
// PAYMENT_REFUNDED para esses mesmos status).
//
// Extraído como função pura pelo mesmo motivo dos outros itens do card: o
// projeto não tem harness de teste para componentes Vue.

const OPEN_INVOICE_STATUSES = ['PENDING', 'OVERDUE'];

/**
 * @param {Array} payments - lista de faturas (mesmo shape de listPayments()).
 * @returns {string}
 */
function getSuspensionMessage(payments) {
  const hasOpenInvoice = Array.isArray(payments)
    && payments.some((payment) => payment && OPEN_INVOICE_STATUSES.includes(payment.status));

  if (hasOpenInvoice) {
    return 'Por favor, regularize sua(s) fatura(s) para continuar usando a plataforma ou entre em contato conosco para mais informações.';
  }

  return 'Seu acesso está suspenso. Fale com o suporte.';
}

module.exports = { getSuspensionMessage, OPEN_INVOICE_STATUSES };
